import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SimpleDropdown } from '../../components/common/SimpleDropdown';
import { TermsModal } from '../../components/legal/TermsModal';

const inputClass =
  'w-full px-4 py-3 rounded-xl bg-jp-field border border-jp-line text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:ring-2 focus:ring-jp-accent/40 focus:border-jp-accent transition text-sm';

export const RegisterCoachPage = () => {
  const navigate = useNavigate();
  const [showTerms, setShowTerms] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    position: '',
    school: '',
    division: '',
    conference: '',
    state: 'Alabama',
    agreeToTerms: false
  });

  const states = [
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' },
  ];

  const divisions = [
    { value: 'NCAA DI', label: 'NCAA DI' },
    { value: 'NCAA DII', label: 'NCAA DII' },
    { value: 'NCAA DIII', label: 'NCAA DIII' },
    { value: 'NAIA', label: 'NAIA' },
    { value: 'Other', label: 'Other' },
  ];

  const conferences = [
    { value: 'ACCAC', label: 'ACCAC (AZ)' },
    { value: 'ACCC', label: 'ACCC (AL)' },
    { value: 'ACCC North', label: 'ACCC North (AL)' },
    { value: 'ACCC South', label: 'ACCC South (AL)' },
    { value: 'Arrowhead Conference', label: 'Arrowhead Conference (IL)' },
    { value: 'Bay Valley Conference', label: 'Bay Valley Conference (CA)' },
    { value: 'CCAC', label: 'CCAC' },
    { value: 'CUNYAC', label: 'CUNYAC (NY)' },
    { value: 'Carolinas', label: 'Carolinas (NC, SC)' },
    { value: 'Central Valley Conference', label: 'Central Valley Conference (CA)' },
    { value: 'Citrus', label: 'Citrus (FL)' },
    { value: 'Coast Conference (North)', label: 'Coast Conference North (CA)' },
    { value: 'Coast Conference (South)', label: 'Coast Conference South' },
    { value: 'EPAC', label: 'EPAC (PA)' },
    { value: 'GCAA North', label: 'GCAA North (GA)' },
    { value: 'GCAA South', label: 'GCAA South (GA)' },
    { value: 'GRAC', label: 'GRAC (IL, IN)' },
    { value: 'GSAC', label: 'GSAC (NJ)' },
    { value: 'Golden Valley Conference', label: 'Golden Valley Conference (Northern CA)' },
    { value: 'ICCAC', label: 'ICCAC (IA, NE)' },
    { value: 'Inland Empire Conference', label: 'Inland Empire Conference (CA)' },
    { value: 'Jayhawk', label: 'Jayhawk (KS)' },
    { value: 'Jayhawk Conference East', label: 'Jayhawk Conference East (KS)' },
    { value: 'Jayhawk Conference West', label: 'Jayhawk Conference West (KS)' },
    { value: 'LCCAC', label: 'LCCAC (LA)' },
    { value: 'MACCC', label: 'MACCC (MS)' },
    { value: 'MCAC', label: 'MCAC (MN, ND, WI)' },
    { value: 'MCCAA', label: 'MCCAA (MI, IN)' },
    { value: 'MCCAC', label: 'MCCAC (MO)' },
    { value: 'MD JUCO', label: 'MD JUCO (MD)' },
    { value: 'MSAC', label: 'MSAC (NY)' },
    { value: 'MWAC', label: 'MWAC (IL)' },
    { value: 'Mid-Hudson', label: 'Mid-Hudson (NY)' },
    { value: 'Mon-Dak', label: 'Mon-Dak (MT, ND)' },
    { value: 'N4C', label: 'N4C (IL, WI)' },
    { value: 'NCCAC', label: 'NCCAC (NC)' },
    { value: 'NJCAA Independent', label: 'NJCAA Independent' },
    { value: 'NTJCAC', label: 'NTJCAC (TX)' },
    { value: 'OCAC', label: 'OCAC (OK)' },
    { value: 'OCCAC', label: 'OCCAC (OH)' },
    { value: 'Orange Empire Conference', label: 'Orange Empire Conference (CA)' },
    { value: 'Pacific Coast Conference', label: 'Pacific Coast Conference (CA)' },
    { value: 'Panhandle', label: 'Panhandle (FL)' },
    { value: 'RMAC', label: 'RMAC (CO, NE, WY)' },
    { value: 'SWAC', label: 'SWAC (UT, NV, ID, CO)' },
    { value: 'SWJCAC', label: 'SWJCAC (TX, NM)' },
    { value: 'Skyway Conference', label: 'Skyway Conference (IL)' },
    { value: 'South Coast Conference', label: 'South Coast Conference (CA)' },
    { value: 'Sun Lakes', label: 'Sun Lakes (AZ)' },
    { value: 'TCCAA Central', label: 'TCCAA Central (TN)' },
    { value: 'TCCAA East', label: 'TCCAA East (TN)' },
    { value: 'TCCAA West', label: 'TCCAA West (TN)' },
    { value: 'VCCS', label: 'VCCS (VA)' },
    { value: 'WJCAC', label: 'WJCAC (TX, NM)' },
    { value: 'WPCC', label: 'WPCC (PA)' },
    { value: 'WSC', label: 'WSC (CA)' },
    { value: 'WTCAC', label: 'WTCAC (TN)' },
    { value: 'Western State Conference', label: 'Western State Conference (CA)' },
  ];


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    // Navigate to plans selection with registration data
    navigate('/auth/plans-selection', {
      state: {
        registrationData: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
          position: formData.position,
          school: formData.school,
          division: formData.division,
          conference: formData.conference,
          state: formData.state,
        },
        role: 'coach',
      },
    });
  };

  const textField = (id, label, name, { type = 'text', placeholder = '', autoComplete } = {}) => (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-jp-ink mb-1.5">{label}</label>
      <input
        id={id}
        type={type}
        name={name}
        autoComplete={autoComplete}
        value={formData[name]}
        onChange={handleChange}
        required
        placeholder={placeholder}
        className={inputClass}
      />
    </div>
  );

  return (
    <main className="min-h-screen bg-jp-page text-jp-ink text-left overflow-x-hidden">
      {/* Navy strip behind the see-through navbar so its white logo and links stay readable */}
      <div className="bg-jp-band h-16 sm:h-20" aria-hidden="true" />

      <TermsModal open={showTerms} onClose={() => setShowTerms(false)} />

      <section className="px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-16 sm:pb-20">
        <div className="max-w-2xl mx-auto text-center mb-8">
          <p className="text-jp-accent dark:text-jp-gold text-sm font-bold uppercase tracking-widest mb-3">
            Step 1
          </p>
          <h1 className="text-5xl sm:text-6xl font-anton leading-[1.1] tracking-tight text-jp-ink">
            REGISTRATION FOR COACH
          </h1>
          <p className="mt-4 text-jp-muted text-sm sm:text-base">
            Tell us about yourself and your program.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-jp-card rounded-2xl border border-jp-outline/70 shadow-sm p-5 sm:p-8">
          <form onSubmit={handleSubmit} className="rounded-xl p-5 sm:p-6 bg-jp-section border border-jp-outline/50 space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {textField('coach-first-name', 'First name', 'firstName', { autoComplete: 'given-name' })}
              {textField('coach-last-name', 'Last name', 'lastName', { autoComplete: 'family-name' })}
            </div>

            {textField('coach-email', 'Work email', 'email', { type: 'email', autoComplete: 'email', placeholder: 'you@school.edu' })}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {textField('coach-password', 'Password', 'password', { type: 'password', autoComplete: 'new-password', placeholder: '8 or more characters' })}
              {textField('coach-confirm-password', 'Confirm password', 'confirmPassword', { type: 'password', autoComplete: 'new-password', placeholder: 'Type it again' })}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {textField('coach-job-title', 'Job title', 'position', { autoComplete: 'organization-title', placeholder: 'e.g. Recruiting Coordinator' })}
              {textField('coach-school', 'School', 'school', { autoComplete: 'organization', placeholder: 'Enter school name' })}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <span className="block text-sm font-semibold text-jp-ink mb-1.5">Division</span>
                <SimpleDropdown
                  value={formData.division}
                  onChange={(value) => handleDropdownChange('division', value)}
                  options={divisions}
                  placeholder="Select division"
                  variant="themed"
                />
              </div>

              {/* Conference */}
              {/* <div>
                <span className="block text-sm font-semibold text-jp-ink mb-1.5">Conference</span>
                <SimpleDropdown
                  value={formData.conference}
                  onChange={(value) => handleDropdownChange('conference', value)}
                  options={conferences}
                  placeholder="Select conference"
                  variant="themed"
                />
              </div> */}

              <div>
                <span className="block text-sm font-semibold text-jp-ink mb-1.5">State</span>
                <SimpleDropdown
                  value={formData.state}
                  onChange={(value) => handleDropdownChange('state', value)}
                  options={states}
                  placeholder="Select state"
                  variant="themed"
                />
              </div>
            </div>

            {/* Terms Checkbox */}
            <div className="flex items-start gap-3 pt-1">
              <input
                id="coach-agree-terms"
                type="checkbox"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleChange}
                required
                className="mt-0.5 w-5 h-5 rounded border-jp-line bg-jp-field text-cyan-500 focus:ring-2 focus:ring-jp-accent/40"
              />
              <label htmlFor="coach-agree-terms" className="text-sm text-jp-ink">
                I have read and agree to the{' '}
                <button
                  type="button"
                  onClick={() => setShowTerms(true)}
                  className="font-semibold text-jp-accent hover:underline"
                >
                  Terms of Service
                </button>
              </label>
            </div>

            <div className="max-w-md mx-auto pt-3">
              <button
                type="submit"
                className="w-full py-4 text-base font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600 text-slate-900 rounded-xl hover:brightness-110 transition-all shadow-lg shadow-cyan-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jp-section active:scale-[0.98]"
              >
                Next
              </button>
            </div>
          </form>

          <p className="px-2 pt-5 pb-1 text-center text-sm sm:text-base text-jp-muted">
            Already have an account?{' '}
            <Link to="/auth/login" className="font-semibold text-jp-accent hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default RegisterCoachPage;
